import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import jwt from 'jsonwebtoken';
import moment from 'moment';
import VueCropper from 'vue-cropper'
import VModal from 'vue-js-modal'

Vue.use(Vuex);
Vue.use(VueCropper);
Vue.use(VModal, { dialog: true });

let adminApiHost = '';
let serverApiHost = '';

if (process.env.ZTO_ENV === 'oper') {
  adminApiHost = 'https://admin-api.banbantaxi.com';
  serverApiHost = 'http://state.banbantaxi.com';
} else {
  adminApiHost = 'https://dev-admin-api.vanvantaxi.com';
  serverApiHost = 'http://dev-pass.banbantaxi.com';
}

window.apiHost = {adminApiHost: adminApiHost, serverApiHost: serverApiHost};

Vue.prototype.$http = axios;
Vue.prototype.moment = moment;
window.moment = moment;

const enhanceAccessToken = () => {
  const { accessToken } = localStorage;
  if (!accessToken) return;
  axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
};
enhanceAccessToken();

export default new Vuex.Store({
  components: {
    jwt  
  },
  state: {
    accessToken: null
  },
  getters: {

  },
  mutations: {
    LOGIN (state, { accessToken }) {
      state.accessToken = accessToken;
      localStorage.accessToken = accessToken;

      const decoded = jwt.decode(accessToken);
      const userName = decoded.userName;
      const exp = decoded.exp + '000';
      const nickName = decoded.nickName;
      const role = decoded.role;

      localStorage.userName = userName;
      localStorage.exp = exp;
      localStorage.nickName = nickName;
      localStorage.role = role;
    },
    LOGOUT (state) {
      state.accessToken = null;
      delete localStorage.accessToken;
      delete localStorage.userName;
      delete localStorage.role;
      delete localStorage.nickName;
      delete localStorage.exp;
    }
  },
  actions: {
    /* 로그인 */
    LOGIN ({ commit }, { id, pw }) {
      axios.defaults.headers.common['Content-Type'] = `application/json; charset=utf-8`;
      axios.defaults.headers.common['Accept'] = 'application/json; charset=utf-8';

      const bodyParameters = {
        'userName': id,
        'password': pw,
      };
      return axios.post(`${adminApiHost}/login`, bodyParameters)
        .then(({ data }) => {
          commit('LOGIN', data);

          // 모든 HTTP 요청 헤더에 Authorization 을 추가한다.   
          axios.defaults.headers.common['Authorization'] = `Bearer ${data.accessToken}`;
        });
    },
    LOGOUT ({ commit }) {
      // HTTP 요청 헤더값 제거 
      axios.defaults.headers.common['Authorization'] = undefined;
      commit('LOGOUT');
    },
    refreshAccessToken ({ commit }) {
      if (localStorage.exp - Date.now() <= 600000) {
        axios.post(`${adminApiHost}/refreshToken`)
          .then(({ data }) => {
            commit('LOGIN', data);
            axios.defaults.headers.common['Authorization'] = `Bearer ${data.accessToken}`;
          });
      }
    },
    banbanAPI (_, parameters) {
      top.getApp.progress.dialog = true;
      this.dispatch('refreshAccessToken');
      parameters.banbanURL = '';
      parameters.banbanRestType = '';

      /* 세션 끊기는거 테스트 */
      // axios.defaults.headers.common['Authorization'] = '';

      /* 실시간 콜 현황 */
      if (parameters.method === 'realTimeCallStats') {
        parameters.banbanURL = `${adminApiHost}/realTimeCallStats`;
        parameters.banbanRestType = `get`;
      }
      else if (parameters.method === 'runningDrivers') {
        parameters.banbanURL = `${adminApiHost}/runningDrivers?page=` + parameters.pageNum + `&size=` + parameters.pageSize + `&sort=` + parameters.sortName + `,` + parameters.order;
        parameters.banbanRestType = `get`;
      }
      else if (parameters.method === 'runningBanBanCalls') {
        parameters.banbanURL = `${adminApiHost}/runningBanBanCalls?page=` + parameters.pageNum + `&size=` + parameters.pageSize + `&sort=` + parameters.sortName + `,` + parameters.order;
        parameters.banbanRestType = `get`;
      }
      else if (parameters.method === 'runningBanBanCallDetail') {
        parameters.banbanURL = `${adminApiHost}/runningBanBanCalls/` + parameters.id;
        parameters.banbanRestType = `get`;
      }
      else if (parameters.method === 'cancelRunningBanBanCall') {
        parameters.banbanURL = `${adminApiHost}/cancelRunningBanBanCall`;
        parameters.banbanRestType = `post`;
      }
      /* 심사 관리 */
      else if (parameters.method === 'pendingDrivers') {
        parameters.banbanURL = `${adminApiHost}/pendingDrivers`;
        parameters.banbanRestType = `get`;
      }
      else if (parameters.method === 'openDialogPicture') {
        parameters.banbanURL = `${adminApiHost}/drivers/` + parameters.id + '/driverImage';
        parameters.banbanRestType = `get`;
      }
      else if (parameters.method === 'openDialogLicense') {
        parameters.banbanURL = `${adminApiHost}/drivers/` + parameters.id + '/license';
        parameters.banbanRestType = `get`;
      }
      else if (parameters.method === 'changeState') {
        parameters.banbanURL = `${adminApiHost}/drivers/` + parameters.id + '/states';
        parameters.banbanRestType = `put`;
      }
      else if (parameters.method === 'changeDriverLicenseNumberAndCompanyName') {
        parameters.banbanURL = `${adminApiHost}/drivers/` + parameters.id + '/driverLicenseNumberAndCompanyName';
        parameters.banbanRestType = `put`;
      }
      /* 기사 회원 관리 */
      else if (parameters.method === 'searchDrivers') {
        parameters.banbanURL = `${adminApiHost}/drivers?page=` + parameters.pageNum + `&size=` + parameters.pageSize + `&sort=` + parameters.sortName + `,` + parameters.order;
        parameters.banbanRestType = `get`;
      }
      else if (parameters.method === 'searchDriverDetails') {
        parameters.banbanURL = `${adminApiHost}/drivers/` + parameters.id + '/details';
        parameters.banbanRestType = `get`;
      }
      else if (parameters.method === 'createDriverImageThumbnail') {
        parameters.banbanURL = `${adminApiHost}/drivers/` + parameters.id + '/driverImageThumbnail';
        parameters.banbanRestType = `post`;
      }
      else if (parameters.method === 'changeTaxiInfo') {
        parameters.banbanURL = `${adminApiHost}/taxis/` + parameters.id;
        parameters.banbanRestType = `put`;
      }
      else if (parameters.method === 'changeDriverBusinessNumber') {
        parameters.banbanURL = `${adminApiHost}/drivers/` + parameters.id + '/businessNumber';
        parameters.banbanRestType = `put`;
      }
      else if (parameters.method === 'changeDriverName') {
        parameters.banbanURL = `${adminApiHost}/drivers/` + parameters.id + '/name';
        parameters.banbanRestType = `put`;
      }
      /* 승객 회원 관리 */
      else if (parameters.method === 'searchPassengers') {
        parameters.banbanURL = `${adminApiHost}/passengers?page=` + parameters.pageNum + `&size=` + parameters.pageSize + `&sort=` + parameters.sortName + `,` + parameters.order;
        parameters.banbanRestType = `get`;
      }
      else if (parameters.method === 'changeStatePassenger') {
        parameters.banbanURL = `${adminApiHost}/passengers/` + parameters.id + '/states';
        parameters.banbanRestType = `put`;
      }
      else if (parameters.method === 'searchPassengerDetails') {
        parameters.banbanURL = `${adminApiHost}/passengers/` + parameters.id + '/details';
        parameters.banbanRestType = `get`;
      }
      /* 이용 이력 */
      else if (parameters.method === 'searchDriverUsageRecords') {
        parameters.banbanURL = `${adminApiHost}/driverUsageRecords?page=` + parameters.pageNum + `&size=` + parameters.pageSize + `&sort=` + parameters.sortName + `,` + parameters.order;
        parameters.banbanRestType = `get`;
      }
      else if (parameters.method === 'driverUsageRecordDetail') {
        parameters.banbanURL = `${adminApiHost}/driverUsageRecords/` + parameters.id;
        parameters.banbanRestType = `get`;
      }
      else if (parameters.method === 'searchPassengerUsageRecords') {
        parameters.banbanURL = `${adminApiHost}/passengerUsageRecords?page=` + parameters.pageNum + `&size=` + parameters.pageSize + `&sort=` + parameters.sortName + `,` + parameters.order;
        parameters.banbanRestType = `get`;
      }
      else if (parameters.method === 'passengerUsageRecordDetail') {
        parameters.banbanURL = `${adminApiHost}/passengerUsageRecords/` + parameters.id;
        parameters.banbanRestType = `get`;
      }
      else if (parameters.method === 'searchPassengerUsageProblemRecords') {
        parameters.banbanURL = `${adminApiHost}/passengerUsageProblemRecords?page=` + parameters.pageNum + `&size=` + parameters.pageSize + `&sort=` + parameters.sortName + `,` + parameters.order;
        parameters.banbanRestType = `get`;
      }
      else if (parameters.method === 'updatePassengerUsageProblemRecord') {
        parameters.banbanURL = `${adminApiHost}/passengerUsageProblemRecords/` + parameters.id;
        parameters.banbanRestType = `put`;
      }
      /* 결제 관리 */
      else if (parameters.method === 'billingHistories') {
        parameters.banbanURL = `${adminApiHost}/billingHistories?page=` + parameters.pageNum + `&size=` + parameters.pageSize + `&sort=` + parameters.sortName + `,` + parameters.order;
        parameters.banbanRestType = `get`;
      }
      else if (parameters.method === 'cancelOrder') {
        parameters.banbanURL = `${adminApiHost}/cancelOrder`;
        parameters.banbanRestType = `post`;
      }
      /* 신고 관리 */
      else if (parameters.method === 'blamedPassengers') {
        parameters.banbanURL = `${adminApiHost}/blamedPassengers?page=` + parameters.pageNum + `&size=` + parameters.pageSize + `&sort=` + parameters.sortName + `,` + parameters.order;
        parameters.banbanRestType = `get`;
      }
      else if (parameters.method === 'changeStateBlamedPassenger') {
        parameters.banbanURL = `${adminApiHost}/blamedPassengers/` + parameters.id + '/states';
        parameters.banbanRestType = `put`;
      }
      /* 쿠폰 */
      else if (parameters.method === 'searchCoupons') {
        parameters.banbanURL = `${adminApiHost}/coupons?page=` + parameters.pageNum + `&size=` + parameters.pageSize + `&sort=` + parameters.sortName + `,` + parameters.order;
        parameters.banbanRestType = `get`;
      }
      else if (parameters.method === 'createCoupons') {
        parameters.banbanURL = `${adminApiHost}/coupons`;
        parameters.banbanRestType = `post`;
      }
      else if (parameters.method === 'editCoupons') {
        parameters.banbanURL = `${adminApiHost}/coupons/` + parameters.id;
        parameters.banbanRestType = `put`;
      }
      else if (parameters.method === 'couponHistories') {
        parameters.banbanURL = `${adminApiHost}/couponHistories?couponId=` + parameters.id + `&page=` + parameters.pageNum + `&size=` + parameters.pageSize + `&sort=` + parameters.sortName + `,` + parameters.order;
        parameters.banbanRestType = `get`;
      }
      else if (parameters.method === 'createCouponHistories') {
        parameters.banbanURL = `${adminApiHost}/couponHistories?page=` + parameters.pageNum + `&size=` + parameters.pageSize + `&sort=` + parameters.sortName + `,` + parameters.order;
        parameters.banbanRestType = `post`;
      }
      else if (parameters.method === 'searchCouponHistoryDetail') {
        parameters.banbanURL = `${adminApiHost}/couponHistories/` + parameters.id;
        parameters.banbanRestType = `get`;
      }
      else if (parameters.method === 'searchBillingHistoryDetail') {
        parameters.banbanURL = `${adminApiHost}/billingHistories/` + parameters.id;
        parameters.banbanRestType = `get`;
      }
      /* 프로모션 코드 관리 */
      // else if (parameters.method === 'searchPromotionCodes') {
      //   parameters.banbanURL = `${adminApiHost}/promotionCodes?page=` + parameters.pageNum + `&size=` + parameters.pageSize + `&sort=` + parameters.sortName + `,` + parameters.order;
      //   parameters.banbanRestType = `get`;
      // }
      // else if (parameters.method === 'searchPromotionCodeDetail') {
      //   parameters.banbanURL = `${adminApiHost}/promotionCodes/` + parameters.id;
      //   parameters.banbanRestType = `get`;
      // }
      // else if (parameters.method === 'editPromotionCodes') {
      //   parameters.banbanURL = `${adminApiHost}/promotionCodes/` + parameters.id;
      //   parameters.banbanRestType = `put`;
      // }
      // else if (parameters.method === 'createPromotionCodes') {
      //   parameters.banbanURL = `${adminApiHost}/promotionCodes`;
      //   parameters.banbanRestType = `post`;
      // }
      // else if (parameters.method === 'searchPromotionCodeHistories') {
      //   parameters.banbanURL = `${adminApiHost}/promotionCodeHistories?promotionCodeId=` + parameters.id + `&page=` + parameters.pageNum + `&size=` + parameters.pageSize + `&sort=` + parameters.sortName + `,` + parameters.order;
      //   parameters.banbanRestType = `get`;
      // }
      /* 승객 정산 관리 */
      else if (parameters.method === 'settlePassengerTaxiFee') {
        parameters.banbanURL = `${adminApiHost}/passenger/settlement`;
        parameters.banbanRestType = `post`;
      }
      /* 기사 정산 관리 */
      else if(parameters.method === 'searchSettlement') {
        parameters.banbanURL = `${adminApiHost}/settlement?aggrDate=` + parameters.aggrDate + '&page=' + parameters.pageNum + `&size=` + parameters.pageSize + `&sort=` + parameters.sortName + `,` + parameters.order;
        parameters.banbanRestType = `get`;
      }
      else if(parameters.method === 'downloadSettlement') {
        parameters.banbanURL = `${adminApiHost}/settlement/attachment/workbook?aggrDate=` + parameters.aggrDate;
        parameters.banbanRestType = `get`;
      }
      else if(parameters.method === 'searchSettlementDetails') {
        parameters.banbanURL = `${adminApiHost}/settlementDetails?aggrDate=` + parameters.aggrDate + '&page=' + parameters.pageNum + `&size=` + parameters.pageSize + `&sort=` + parameters.sortName + `,` + parameters.order;
        parameters.banbanRestType = `get`;
      }
      else if(parameters.method === 'downloadSettlementDetails') {
        parameters.banbanURL = `${adminApiHost}/settlementDetails/attachment/workbook?aggrDate=` + parameters.aggrDate;
        parameters.banbanRestType = `get`;
      }
      /* 서버 관리 */
      else if (parameters.method === 'serverStates') {
        parameters.banbanURL = `${serverApiHost}/serverStates`;
        parameters.banbanRestType = `get`;
      }
      else if (parameters.method === 'updateStates') {
        parameters.banbanURL = `${serverApiHost}/serverStates`;
        parameters.banbanRestType = `put`;
      }
      /* APP PUSH */
      else if (parameters.method === 'searchPushMessages') {
        parameters.banbanURL = `${adminApiHost}/pushMessages?page=` +  parameters.pageNum + `&size=` + parameters.pageSize + `&sort=` + parameters.sortName + `,` + parameters.order;
        parameters.banbanRestType = `get`;
      }
      else if (parameters.method === 'searchPushMessageDetail') {
        parameters.banbanURL = `${adminApiHost}/pushMessages/` + parameters.id;
        parameters.banbanRestType = `get`;
      }
      else if (parameters.method === 'searchPushMessageTargets') {
        parameters.banbanURL = `${adminApiHost}/pushMessages/` + parameters.id + `/targets`;
        parameters.banbanRestType = `get`;
      }
      else if (parameters.method === 'createPushMessages') {
        parameters.banbanURL = `${adminApiHost}/pushMessages`;
        parameters.banbanRestType = `post`;
      }
      else if (parameters.method === 'editPushMessages') {
        parameters.banbanURL = `${adminApiHost}/pushMessages/` + parameters.id;
        parameters.banbanRestType = `put`;
      }
      else if (parameters.method === 'deletePushMessage') {
        parameters.banbanURL = `${adminApiHost}/pushMessages/` + parameters.id;
        parameters.banbanRestType = `delete`;
      }
      else if(parameters.method === 'downloadAppPushTargetForm') {
        parameters.banbanURL = `${adminApiHost}/pushMessages/attachment/workbook`;
        parameters.banbanRestType = `get`;
      }
      /* 포인트 */
      else if (parameters.method === 'createPointPassenger') {
        parameters.banbanURL = `${adminApiHost}/pointPassengers`;
        parameters.banbanRestType = `post`;
      }
      /* SMS */
      else if (parameters.method === 'sendingSMS') {
        parameters.banbanURL = `${adminApiHost}/sms`;
        parameters.banbanRestType = `post`;
      }
      else if (parameters.method === 'SMSList') {
        parameters.banbanURL = `${adminApiHost}/smsList?pageNum=` + parameters.pageNum + `&pageSize=` + parameters.pageSize;
        parameters.banbanRestType = `get`;
      }
      else if (parameters.method === 'smsRemainCount') {
        parameters.banbanURL = `${adminApiHost}/smsRemainCount`;
        parameters.banbanRestType = `get`;
      }
      else if (parameters.method === 'searchUsers') {
        parameters.banbanURL = `${adminApiHost}/users?page=` + parameters.pageNum + `&size=` + parameters.pageSize + `&sort=` + parameters.sortName + `,` + parameters.order;
        parameters.banbanRestType = `get`;
      }
      /* VOC */
      else if (parameters.method === 'vocs') {
        parameters.banbanURL = `${adminApiHost}/vocs?page=` +  parameters.pageNum + `&size=` + parameters.pageSize + `&sort=` + parameters.sortName + `,` + parameters.order;
        parameters.banbanRestType = `get`;
      }
      else if (parameters.method === 'createVOC') {
        parameters.banbanURL = `${adminApiHost}/vocs`;
        parameters.banbanRestType = `post`;
      }
      else if (parameters.method === 'searchVOCDetails') {
        parameters.banbanURL = `${adminApiHost}/vocs/` + parameters.id;
        parameters.banbanRestType = `get`;
      }
      else if (parameters.method === 'deleteVOC') {
        parameters.banbanURL = `${adminApiHost}/vocs/` + parameters.id;
        parameters.banbanRestType = `delete`;
      }
      else if (parameters.method === 'updateVOC') {
        parameters.banbanURL = `${adminApiHost}/vocs/` + parameters.id + `/registerContents`;
        parameters.banbanRestType = `put`;
      }
      else if (parameters.method === 'updateProcessStates') {
        parameters.banbanURL = `${adminApiHost}/vocs/` + parameters.id + `/processStates`;
        parameters.banbanRestType = `put`;
      }
      else if (parameters.method === 'simulation') {
        parameters.banbanURL = `${adminApiHost}/simulation`;
        parameters.banbanRestType = `post`;
      }
      else if (parameters.method === 'callEventUsers') {
        parameters.banbanURL = `${adminApiHost}/callEventUsers`;
        parameters.banbanRestType = `get`;
      }
      else if (parameters.method === 'createBanBanEventCall') {
        parameters.banbanURL = `${adminApiHost}/createBanBanEventCall`;
        parameters.banbanRestType = `post`;
      }

      /* 공통 필터 추가 */
      if(parameters.filter != null && parameters.filter != ''
        && parameters.filterText != null && parameters.filterText != '') {
          parameters.banbanURL = parameters.banbanURL + `&` + parameters.filter + `=` + parameters.filterText;
        }

      return axios({
        method: parameters.banbanRestType,
        url: parameters.banbanURL,
        responseType: parameters.responseType,
        data: parameters,
      })
        .catch((error) => {
          if (error.response.data.statusCode === 401
              || error.response.data.statusCode === 403
              || error.response.data.message === 'INVALID_AUTHORIZATION_TYPE'
              || error.response.data.message === 'UNAUTHORIZED') {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
            top.getApp.progress.dialog = false;
            window.getApp.$emit('APP_AUTH_FAILED');
            top.getApp.commonError = 'APP_AUTH_FAILED';
          }
          else if (error.response.data.errorCode === 303
            && error.response.data.message === 'DANAL_API_ERROR') {
            top.getApp.commonError = 'DANAL_API_ERROR';
            alert('환불을 실패하였습니다.');
          }
          else if (error.response.data.errorCode === 304
            && error.response.data.message === 'ALREADY_REFUNDED') {
            top.getApp.commonError = 'ALREADY_REFUNDED';
            alert('이미 환불처리 된 내역입니다.');
            let result = { data: { status: 'OK' }};
            return result;
          }
          else {
            // if (top.getApp.commonError == null) {
            //   alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
            // }
            // top.getApp.commonError = null;
          }
          top.getApp.progress.dialog = false;
        });
    }
  }
}); 



// WEBPACK FOOTER //
// ./src/store/index.js